import React from "react";
import RequestCodeView from "./RequestCodeView";

interface ErrorLogDetailsPanelProps {
  url?: string;
  statusMessage?: string;
  requestText: string;
  onOpenCodeModal: (e: React.MouseEvent, requestText: string) => void;
}

const ErrorLogDetailsPanel: React.FC<ErrorLogDetailsPanelProps> = ({
  url,
  statusMessage,
  requestText,
  onOpenCodeModal,
}) => {
  return (
    <div className="px-6 py-6 mx-8">
      <div className="flex flex-col gap-6">
        {/* URL Section */}
        {url && (
          <div>
            <div className="text-sm font-medium text-gray-700 mb-2">URL</div>
            <div className="text-sm text-gray-600 break-all select-all bg-white px-3 py-2 rounded border border-gray-300">
              {url}
            </div>
          </div>
        )}

        <div className="flex justify-between gap-10">
          <div className="w-80 flex-shrink-0">
            <div className="text-sm font-medium text-gray-700 mb-3">
              Status message
            </div>
            <div className="text-sm text-gray-600 leading-relaxed">
              {statusMessage ||
                "The request wasn't successful after automatic retries."}
            </div>
          </div>

          <div className="flex-1 min-w-0">
            <div className="text-sm font-medium text-gray-700 mb-3">Request</div>
            <RequestCodeView
              requestText={requestText}
              onClick={(e) => onOpenCodeModal(e, requestText)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorLogDetailsPanel;
